import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/lib/i18n";
import App from "@/App";

// Disable the right-click context menu site-wide (mild deterrent against casual
// copying — it is NOT a security boundary). Editable fields keep their native
// menu so users can still right-click → paste an IBAN, address, etc. Skipped in
// development so DevTools "Inspect" stays reachable.
if (process.env.NODE_ENV === "production") {
  document.addEventListener("contextmenu", (e) => {
    if (e.target.closest('input, textarea, select, [contenteditable="true"]')) return;
    e.preventDefault();
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register the PWA service worker (enables install + Android TWA packaging).
// Auto-update: when a new service worker takes control, reload once so the
// installed app always shows the latest deploy instead of stale cached code.
if ("serviceWorker" in navigator) {
  let reloading = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (reloading) return;
    reloading = true;
    window.location.reload();
  });

  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").then((reg) => {
      // Check for a new version on load and roughly hourly while the app is open.
      reg.update().catch(() => {});
      setInterval(() => reg.update().catch(() => {}), 60 * 60 * 1000);
      // When a new worker has installed and we already control the page, activate it.
      reg.addEventListener("updatefound", () => {
        const sw = reg.installing;
        if (!sw) return;
        sw.addEventListener("statechange", () => {
          if (sw.state === "installed" && navigator.serviceWorker.controller) {
            sw.postMessage("SKIP_WAITING");
          }
        });
      });
    }).catch(() => {});
  });
}
